import React from 'react'
import styles from './ControlsTabContent.module.scss'
import {TranslationObject} from '@colonist/i18n'
import {T} from '@colonist/ui'

interface ControlsTabShortcut {
    title: TranslationObject
    value: TranslationObject[]
}

const ShortcutKeysContainer = ({
    title,
    shortcutKeys,
}: {
    title: TranslationObject
    shortcutKeys: ControlsTabShortcut[]
}) => <div>
    <div className={styles.heading}><T id={title} /></div>
    <div className={styles.shortcutKeys}>
        {shortcutKeys.map((shortcut) => <React.Fragment key={shortcut.title.key}>
            <div className={styles.controlKeysTitle}><T id={shortcut.title} /></div>
            <div className={styles.controlKeys}>
                {shortcut.value.map((key, index) => (
                    <React.Fragment key={index}>
                        <div className={styles.controlKey}><T id={key} /></div>
                        {index < shortcut.value.length - 1 && <div>/</div>}
                    </React.Fragment>
                ))}
            </div>
        </React.Fragment>)}
    </div>
</div>

export const ControlsTabContent = () => {
    const GAME_SHORTCUTS: ControlsTabShortcut[] = [{
        title: {key: 'strings:game.settings.controlsTab.rollDice'},
        value: [{key: 'strings:game.settings.controlsTab.spacebar'}],
    }, {
        title: {key: 'strings:game.settings.controlsTab.endTurn'},
        value: [{key: 'strings:game.settings.controlsTab.spacebar'}],
    }, {
        title: {key: 'strings:game.settings.controlsTab.pauseGame'},
        value: [{key: 'strings:colonistCommon.utils.#buffer', options: {value: 'P'}}],
    }, {
        title: {key: 'strings:game.settings.controlsTab.fullScreen'},
        value: [{key: 'strings:colonistCommon.utils.#buffer', options: {value: 'F'}}],
    }]

    const AUDIO_SHORTCUTS: ControlsTabShortcut[] = [{
        title: {key: 'strings:game.settings.controlsTab.mute'},
        value: [{key: 'strings:colonistCommon.utils.#buffer', options: {value: 'M'}}],
    }, {
        title: {key: 'strings:game.settings.controlsTab.volume'},
        value: [
            {key: 'strings:colonistCommon.utils.#buffer', options: {value: '▲'}},
            {key: 'strings:colonistCommon.utils.#buffer', options: {value: '▼'}},
        ],
    }]

    return <div className={styles.container}>
        <ShortcutKeysContainer
            shortcutKeys={GAME_SHORTCUTS}
            title={{key: 'strings:game.settings.controlsTab.gameShortcuts'}}
        />
        <ShortcutKeysContainer
            shortcutKeys={AUDIO_SHORTCUTS}
            title={{key: 'strings:game.settings.controlsTab.audioShortcuts'}}
        />
    </div>
}
